var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('v-pagination',_vm._g(_vm._b({},'v-pagination',_vm.$attrs,false),_vm.$listeners)),_c('span',{staticClass:"pg-numbers",domProps:{"textContent":_vm._s((_vm.nbPages + " pages"))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }